// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Ce1R","amount":"Amount_amount__2Cw-Q","tip":"Amount_tip__3gnI8","tipHeader":"Amount_tipHeader__3iTMv","tipsWrap":"Amount_tipsWrap__2CP_E"};